<template>
  <v-data-table
    :headers="tabela.headers"
    :items="perfis"
    :search="tabela.opcoes.pesquisa"
    :custom-filter="customFilter"
    :sort-by="tabela.opcoes.ordenarPor"
    :sort-desc="tabela.opcoes.decrescente"
    item-key="id"
    show-expand
    single-expand
  >
    <!-- Ordenação e Pesquisa -->
    <template v-slot:top>
      <v-row>
        <v-col cols="12" md="4">
          <app-sort v-model="tabela.opcoes" />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="4">
          <app-search v-model="tabela.opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- Numeração -->
    <template v-slot:[`item.numero`]="{ index }">
      <span>{{ index + 1 }}</span>
    </template>

    <!-- Idiomas --->
    <template v-slot:[`item.idiomas`]="{ item }">
      {{ item[idiomasAttr].map((a) => a.nome).join(', ') }}
    </template>

    <!-- Instrutor -->
    <template v-slot:[`item.isInstrutor`]="{ item }">
      {{ getIsInstrutor(item[isInstrutorAttr]) }}
    </template>

    <!-- Cursos Cadastrados (Botão de Expansão) -->
    <template
      v-slot:[`item.data-table-expand`]="{
        item,
        expand,
        isExpanded,
      }"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            height="100%"
            text
            width="100%"
            @click="expand(!isExpanded)"
            v-on="on"
          >
            <v-badge right>
              <template v-slot:badge>
                <span>{{
                  item[cursosAttr].length
                }}</span>
              </template>
              <v-icon
                color="grey lighten-0"
                large
              >
                school
              </v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Clique para exibir os cursos cadastrados</span>
      </v-tooltip>
    </template>

    <!-- Cursos Cadastrados (Lista Expandida) -->
    <template v-slot:expanded-item="{ headers, item }">
      <td
        :colspan="headers.length"
        class="justify-center"
      >
        <v-row>
          <v-spacer />
          <v-col>
            <v-row class="justify-center">
              <app-title texto="CURSOS CADASTRADOS" />
            </v-row>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="10">
            <v-simple-table class="elevation-0 mb-4">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      NOME DO CURSO
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="curso in item[cursosAttr]"
                    :key="curso.id"
                  >
                    <td>
                      <div class="d-flex flex-row ma-1">
                        <span>{{ curso.nome }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-spacer />
        </v-row>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import { pesquisar } from '@/modules/texto';

export default {
  name: 'TabelaResultadoUnidadeFormacao',

  components: {
    AppTitle,
    AppSort,
    AppSearch,
  },

  props: {
    relatorio: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    idiomasAttr: {
      type: String,
      required: true,
    },
    isInstrutorAttr: {
      type: String,
      required: true,
    },
    cursosAttr: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      tabela: {
        headers: [
          {
            text: 'N°',
            value: 'numero',
            width: '10%',
            sortable: false,
          },
          {
            text: 'SERVIDOR',
            value: 'servidor',
            sortable: false,
          },
          {
            text: 'NÍVEL DE ESCOLARIDADE',
            value: 'nivelEscolaridade.nome',
            sortable: false,
          },
          {
            text: 'IDIOMAS',
            value: 'idiomas',
            width: '20%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'INSTRUTOR DE CAPACITAÇÃO',
            value: 'isInstrutor',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'CURSOS CADASTRADOS',
            value: 'data-table-expand',
            width: '10%',
            align: 'center',
          },
        ],
        opcoes: {
          pesquisa: '',
          decrescente: false,
          ordenarPor: 'servidor',
          selecionado: { id: 'servidor', descricao: 'Servidor' },
          lista: [
            { id: 'servidor', descricao: 'Servidor' },
            { id: 'nivelEscolaridade.nome', descricao: 'Nível de Escolaridade' },
            { id: 'idiomasOrdenacao', descricao: 'Idiomas' },
            { id: 'isInstrutorOrdenacao', descricao: 'Instrutor de Capacitação' },
            { id: 'cursosOrdenacao', descricao: 'Cursos Cadastrados' },
          ],
        },
      },
    };
  },

  computed: {
    perfis() {
      return this.relatorio.perfis.map((p) => ({
        ...p,
        idiomasOrdenacao: p[this.idiomasAttr].length,
        isInstrutorOrdenacao: this.getIsInstrutorOrdenacao(p[this.isInstrutorAttr]),
        cursosOrdenacao: p[this.cursosAttr].length,
      }));
    },
  },

  methods: {
    getIsInstrutor(status) {
      if (status === null) {
        return 'Não respondeu';
      }
      if (status) {
        return 'Sim';
      }
      return 'Não';
    },
    getIsInstrutorOrdenacao(status) {
      if (status === null) {
        return 3;
      }
      if (status) {
        return 1;
      }
      return 2;
    },
    customFilter(value, search, item) {
      return (
        pesquisar(item.servidor, search)
        || pesquisar(item.nivelEscolaridade ? item.nivelEscolaridade.nome : '', search)
        || item[this.idiomasAttr].some((a) => pesquisar(a.nome, search))
        || (item[this.isInstrutorAttr] === true && pesquisar('sim', search))
        || (item[this.isInstrutorAttr] === false && pesquisar('nao', search))
        || (item[this.isInstrutorAttr] === null && pesquisar('nao respondeu', search))
        || item[this.cursosAttr].some((c) => pesquisar(c.nome, search))
      );
    },
  },
};
</script>
